import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {baseStyles, FIELD_SPACE, withMediaQueries, withMultipleStyles} from "../../../styles/Styles";
import Space from "../commons/Space";
import {addNewRewardInActivity, fetchActivityWinRewards} from "../../actions/activitiesActions";
import TextField from "@material-ui/core/TextField";
import ValueHelper, {textFieldIntegerOnKeyDown} from "../../utils/ValueHelper";
import constants from "../../constants";
import FileHelper from "../../utils/FileHelper";
import FormControl from "@material-ui/core/FormControl";
import {IMAGE_MAX_SIZE, IMAGE_MAX_WIDTH_HEIGHT} from "../commons/FilePicker";
import {cloneDeep, map} from "lodash";
import InputLabel from "@material-ui/core/InputLabel";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import SingleFilePicker, {ACCEPTED_IMAGE_MIMES} from "../commons/SingleFilePicker";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FullWidthDummyView from "../commons/FullWidthDummyView";

const useStyles = (theme) => ({
});

const AUTO_RESTART_DAYS = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.autoRestartNone'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.autoRestartDaily'/>},
  {'id': 3, 'name': <FormattedMessage id='activity.manage.autoRestart3Days'/>},
  {'id': 7, 'name': <FormattedMessage id='activity.manage.autoRestart7Days'/>},
  {'id': 10, 'name': <FormattedMessage id='activity.manage.autoRestart10Days'/>},
];

const CHALLENGE_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.winnersByRandom'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.winnersByTopViewed'/>},
  {'id': 2, 'name': <FormattedMessage id='activity.winnersByTopLiked'/>},
  {'id': 3, 'name': <FormattedMessage id='activity.winnersByDownloadedOnly'/>},
];

class ManageActivityRecur extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;
    this.key = 0;

    const resetGameDays = activityData.consumeLimitPerDay || 0;
    this.enableLoyaltyReward = activityData.usageType === constants.activity.usageTypes.LOYALTY;
    this.disableWinLimit = activityData.type === constants.activity.types.EVENT
      || activityData.type === constants.activity.types.SOCIAL_CONTENT;
    this.enableWinGLimit = !this.disableWinLimit && (activityData.type === constants.activity.types.JACKPOT
        || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
        || activityData.type === constants.activity.types.GAME_BETTING_PIC
        || activityData.type === constants.activity.types.GAME_ROULETTE
        || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || activityData.type === constants.activity.types.GAME_FLIP_CARD
        || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
        || activityData.type === constants.activity.types.GAME_MATCH_PAIR
        || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
        || activityData.type === constants.activity.types.GAME_POKER
        || activityData.type === constants.activity.types.GAME_MATCH_THREE
        || activityData.type === constants.activity.types.GAME_PUZZLE
        || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
        || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
        || activityData.type === constants.activity.types.GAME_BRAND_RACE
        || activityData.type === constants.activity.types.QUESTIONNAIRE
        || activityData.type === constants.activity.types.SURVEY);
    this.enableSlotValues = activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GUESS
      || activityData.type === constants.activity.types.QUESTION
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.SOCIAL_CONTENT
      || activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION;

    if (activityData.rewardState === constants.activity.state.ACTIVE) {
      if (!activityData.winLimit && activityData.winLimit !== 0) {
        activityData.winLimit = constants.activity.VALUE_DEFAULT_MAX;
      }
      if (!activityData.winGLimit && activityData.winGLimit !== 0) {
        activityData.winGLimit = constants.activity.VALUE_DEFAULT_MAX;
      }
    }

    this.slotMinValues = 0;
    this.slotMaxValues = 0;
    this.maxWinOffersCount = 1;
    if (activityData.activityConfigs) {
      this.slotMinValues = activityData.activityConfigs.slotMinValues;
      this.slotMaxValues = activityData.activityConfigs.slotMaxValues;
      this.maxWinOffersCount = activityData.activityConfigs.maxWinOffersCount;
    }
    this.slotValues = [];
    if (this.enableSlotValues) {
      if (activityData.slotValues) {
        activityData.slotValues.forEach((option) => {
          if (activityData.rewardState === constants.activity.state.ACTIVE) {
            if (!option.winLimit && option.winLimit !== 0) {
              option.winLimit = constants.activity.VALUE_DEFAULT_MAX;
            }
          }
          option.winLimit = option.winLimit ? ''+ option.winLimit : '0';
          option.points = option.points ? ''+ option.points : '0';
          option.value1 = option.value1 ? ''+ option.value1 : '0';

          this.slotValues.push({
            id: option.id,
            number: option.number,
            imageUrl: option.imageUrl,
            imageFiles: option.imageFiles,
            isImageDeleted: option.isImageDeleted,
            offers: !this.enableLoyaltyReward ? option.offers : null,
            points: this.enableLoyaltyReward ? option.points : '0',
            value1: option.value1,
            winLimit: option.winLimit,
            winILimit: option.winILimit,
            state: option.state,
          });
        });
      } else {
        activityData.slotValues = [];
      }
    }

    let rewardsData = null;
    if (this.enableSlotValues) {
      rewardsData = cloneDeep(this.slotValues[0]);
      rewardsData.winPoints = rewardsData.points;
    } else {
      rewardsData = {
        winLimit: activityData.winLimit,
        winPoints: activityData.winPoints,
        offers: null,
      };
      if (activityData.offer) {
        rewardsData.offers = [activityData.offer];
      }
    }
    rewardsData.winGLimit = activityData.winGLimit;
    if (this.enableLoyaltyReward) {
      rewardsData.offers = activityData.loyaltyRewards;
    }
    const rewardState = activityData.rewardState;

    this.winnersByOptions = null;
    let winnersBySelected = null;
    if (activityData.type === constants.activity.types.CHALLENGE) {
      this.winnersByOptions = CHALLENGE_WINNERS_BY;

      winnersBySelected = null;
      this.winnersByOptions.forEach((typeObj) => {
        if (activityData.winnersBy == typeObj.id) {
          winnersBySelected = typeObj;
        }
      });
      if (!winnersBySelected) {
        winnersBySelected = this.winnersByOptions[0];
      }
    }

    this.state = {
      sections: [
        {id: 1, labelId: 'activity.manage.sectionResetDays', expand: true, expandAlways: true, subLabelId: 'activity.manage.sectionHintAutoRestart'},
      ],
      boxType: rewardState === constants.activity.state.DELETE ? 0 : 1,
      rewardState: rewardState,
      newReward: null,
      newRewardError: null,
      isNewRewardAdded: false,
      rewardsData: rewardsData,
      winGLimit: rewardsData.winGLimit ? (rewardsData.winGLimit != constants.activity.VALUE_DEFAULT_MAX ? ''+ rewardsData.winGLimit : '') : '0',
      winLimit: rewardsData.winLimit ? (rewardsData.winLimit != constants.activity.VALUE_DEFAULT_MAX ? ''+ rewardsData.winLimit : '') : '0',
      winPoints: this.enableLoyaltyReward && rewardsData.winPoints ? rewardsData.winPoints : '',
      activityRewarded: null,
      activityRewardedSearch: '',
      isActivityRewardedLoading: false,
      winnersBySelected: winnersBySelected,
      winnersByValue: activityData.winnersByValue || '0',
      showValidationMsg: false,
      showNewRewardValidationMsg: false,
      resetGameDays: resetGameDays,
      reload: false,
    };

    this.rewardOptions = [];
    if (!this.enableLoyaltyReward) {
      this.rewardOptions.push({'id': 0, 'name': <FormattedMessage id='activity.manage.noRewards'/>, 'details': <FormattedMessage id='activity.manage.noRewardsM'/>, 'image': require('src/images/img_usage_type_branding.png')});
    }
    this.rewardOptions.push({'id': 1, 'name': <FormattedMessage id='activity.manage.selectRewards'/>, 'details': <FormattedMessage id='activity.manage.selectRewardsM'/>, 'image': require('src/images/img_usage_type_school.png')});
    this.rewardOptions.push({'id': 2, 'name': <FormattedMessage id='activity.manage.addNewReward'/>, 'details': <FormattedMessage id='activity.manage.addNewRewardM'/>, 'image': require('src/images/img_usage_type_employee.png')});
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    // this.fetchActivityWinRewards();
  }

  componentWillUnmount() {
    if (this.timeoutHandleId) {
      clearTimeout(this.timeoutHandleId);
    }
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false, showNewRewardValidationMsg: false});
  }

  getData(excludeError) {
    const {activityData} = this.props;
    let {
      rewardState,
      rewardsData,
      newReward,
      winGLimit,
      winLimit,
      winPoints,
      resetGameDays,
      winnersBySelected,
      winnersByValue,
    } = this.state;

    if (!excludeError) {
      if (newReward) {
        this.setState({showValidationMsg: true});
        return false;
      }
      if (this.enableLoyaltyReward && activityData.type !== constants.activity.types.EVENT) {
        if (!winPoints || ValueHelper.getEnglishValue(winPoints) <= 0) {
          this.setState({showValidationMsg: true});
          return false;
        }
      }
      if (rewardState === constants.activity.state.ACTIVE && !this.areWinValuesCorrect()) {
        this.setState({showValidationMsg: true});
        return false;
      }
    }

    const data = {
      rewardState,
      isRewardStateUpdated: true,
      winGLimit,
      winPoints,
      consumeLimitPerDay: resetGameDays,
    };
    if (this.enableSlotValues) {
      this.slotValues.forEach((slot) => {
        slot.winLimit = winLimit;
        if (this.enableLoyaltyReward) {
          slot.offers = null;
          slot.points = winPoints;
        } else {
          slot.offers = rewardsData.offers;
          slot.points = 0;
        }
      });
    } else {
      data.winLimit = winLimit;
      if (this.enableLoyaltyReward) {
        data.offer = null;
        data.offerId = 0;
        data.winPoints = winPoints;
      } else {
        data.offer = rewardsData.offers && rewardsData.offers.length > 0 ? rewardsData.offers[0] : null;
        data.offerId = rewardsData.offers && rewardsData.offers.length > 0 ? rewardsData.offers[0].id : null;
        data.winPoints = 0;
      }
    }
    if (this.enableSlotValues) {
      data.slotValues = this.slotValues;
    }
    if (this.enableLoyaltyReward) {
      data.loyaltyRewards = rewardsData.offers;
    }
    if (activityData.type === constants.activity.types.CHALLENGE) {
      data.winnersBy = winnersBySelected ? winnersBySelected.id : 0;
      data.winnersByValue = winnersByValue;
    }
    return data;
  }

  render() {
    const {
      rewardState,
      rewardsData,
      showValidationMsg,
      showNewRewardValidationMsg,
      sections,
      newReward,
      newRewardError,
      winGLimit,
      winLimit,
      winPoints,
      resetGameDays,
      winnersBySelected,
      winnersByValue,
      snackbarMessageId
    } = this.state;
    const {activities, activityData, classes, isXS} = this.props;

    let placeholderTitleId = null;
    let placeholderImageId = null;
    if (newReward) {
      if (newReward.type === constants.activity.types.OFFER) {
        placeholderTitleId = 'activity.manage.offerTitle';
        placeholderImageId = 'activity.manage.offerImage';
      } else if (newReward.type === constants.activity.types.VOUCHER) {
        placeholderTitleId = 'activity.manage.voucherTitle';
        placeholderImageId = 'activity.manage.voucherImage';
      }
    }
    let showWinLimit = !this.disableWinLimit && (this.enableSlotValues
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS);

    const winRewardsError = showValidationMsg && (!rewardsData.offers || rewardsData.offers.length === 0);
    const winLimitError = showValidationMsg && winLimit && ValueHelper.getEnglishValue(winLimit) <= 0;
    const winGLimitError = showValidationMsg && this.enableWinGLimit && resetGameDays > 0 && (winGLimit && ValueHelper.getEnglishValue(winGLimit) <= 0);

    const newRewardErrorEff = newRewardError || <FormattedMessage id={'activity.manage.saveRewardError'} />;
    const newRewardVoucherError = showNewRewardValidationMsg && newReward.type === constants.activity.types.VOUCHER && newReward.vouchers.length === 0;
    const newRewardLoyaltyPointsError = showNewRewardValidationMsg && this.enableLoyaltyReward
      && (!newReward.fee || ValueHelper.getEnglishValue(newReward.fee) <= 0);

    let winPointsError = showValidationMsg && winLimit && ValueHelper.getEnglishValue(winLimit) <= 0;
    let topHintLabelId;
    let titleLoyaltyPoints;
    let hintLoyaltyPoints;
    if (activityData.type === constants.activity.types.EVENT) {
      topHintLabelId = activityData.usageType === constants.activity.usageTypes.LOYALTY ? 'activity.manage.topHintEventLoyaltyRewards' : 'activity.manage.topHintEventRewards';
      titleLoyaltyPoints = 'activity.eventPoints';
      hintLoyaltyPoints = 'activity.hintLoyaltyPointsParticipants';
    } else {
      winPointsError = showValidationMsg && (!winPoints || ValueHelper.getEnglishValue(winPoints) <= 0);
      topHintLabelId = activityData.usageType === constants.activity.usageTypes.LOYALTY ? 'activity.manage.topHintLoyaltyRewards' : 'activity.manage.topHintRewards';
      titleLoyaltyPoints = 'activity.winPoints';
      hintLoyaltyPoints = 'activity.hintLoyaltyPointsWinners';
    }
    const extraHorizontalMargin = isXS ? 0 : 12;

    const showResetGameDays = (activityData.usageType === constants.activity.usageTypes.MARKETING || activityData.usageType === constants.activity.usageTypes.LOYALTY)
      && (activityData.type === constants.activity.types.JACKPOT
        || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
        || activityData.type === constants.activity.types.GAME_BETTING_PIC
        || activityData.type === constants.activity.types.GAME_ROULETTE
        || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || activityData.type === constants.activity.types.GAME_FLIP_CARD
        || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
        || activityData.type === constants.activity.types.GAME_MATCH_PAIR
        || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
        || activityData.type === constants.activity.types.GAME_POKER
        || activityData.type === constants.activity.types.GAME_MATCH_THREE
        || activityData.type === constants.activity.types.GAME_PUZZLE
        || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
        || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
        || activityData.type === constants.activity.types.GAME_BRAND_RACE
        || activityData.type === constants.activity.types.QUESTIONNAIRE
        || activityData.type === constants.activity.types.SURVEY
      );

    const showGameWinnersBy = activityData.type === constants.activity.types.CHALLENGE;
    if (showGameWinnersBy && winnersBySelected && winnersBySelected.id === 3) {
      showWinLimit = false;
    }

    const inputSpace = FIELD_SPACE;
    return (
      <div className={classes.viewColumnFullWidth}>
        <FullWidthDummyView />
        {showResetGameDays ?
          <div className={classes.formActivitySmall} style={{padding: 0, marginBottom: 1.5 * inputSpace}}>
            {/*{this.getFormSectionHeaderView(sections[0])}*/}
            {/*{sections[0].expand ?*/}
              <div className={classes.viewColumnFullWidth} style={{padding: 16, paddingBottom: 0}}>
                <FormControl
                  required
                  size="small"
                  fullWidth
                  variant="filled">
                  <InputLabel id="dropDown"><FormattedMessage id={'activity.manage.resetGameDays'} /></InputLabel>
                  <Select
                    labelId="dropDown"
                    required
                    id="resetGameDays"
                    name="resetGameDays"
                    value={resetGameDays}
                    disableUnderline={true}
                    onChange={this.onChange}>
                    {map(AUTO_RESTART_DAYS, (type) => {
                      return (
                        <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                      )
                    })
                    }
                  </Select>
                </FormControl>
                <Space horizontal={inputSpace}/>
              </div>
            {/*  : null*/}
            {/*}*/}
          </div>
          : null
        }

        {!this.enableLoyaltyReward || ValueHelper.getEnglishValue(winPoints) > 0 ?
          <div className={classes.viewColumnFullWidth}>
            {rewardState === constants.activity.state.ACTIVE ?
              <div className={classes.viewColumnFullWidth}>
                {!this.enableLoyaltyReward && (showWinLimit || (this.enableWinGLimit && resetGameDays > 0) || showGameWinnersBy) ?
                  <div className={classes.formActivitySmall}>
                    {showGameWinnersBy ?
                      <div className={classes.container}>
                        <FormControl
                          size="small"
                          fullWidth
                          variant="filled">
                          <InputLabel id="dropDown"><FormattedMessage id={'activity.winnersBy'} /></InputLabel>
                          <Select
                            labelId="dropDown"
                            required
                            id="winnersBySelected"
                            name="winnersBySelected"
                            value={winnersBySelected}
                            disableUnderline={true}
                            onChange={this.onChange}>
                            {map(this.winnersByOptions, (type) => {
                              return (
                                <MenuItem key={type.id} value={type}>{type.name}</MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>
                        <Space horizontal={inputSpace} />
                      </div>
                      : null
                    }

                    {showGameWinnersBy && winnersBySelected && winnersBySelected.showWinnersByValue ?
                      <div className={classes.container}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          size="small"
                          type="number"
                          id="winnersByValue"
                          name="winnersByValue"
                          label={<FormattedMessage id={'activity.manage.minValueToWinEligible'} />}
                          value={winnersByValue}
                          inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}
                          onChange={this.onChange}
                        />
                        <Space horizontal={inputSpace}/>
                      </div>
                      : null
                    }

                    {showWinLimit ?
                      <div className={classes.viewColumnFullWidth}>
                        <TextField
                          variant="filled"
                          fullWidth
                          size="small"
                          type="number"
                          id="winLimit"
                          name="winLimit"
                          // label={<FormattedMessage id={this.enableWinGLimit && resetGameDays > 0 ? 'activity.manage.winLimitPerRecurring' : 'activity.manage.winGLimit'} />}
                          label={<FormattedMessage id={'activity.manage.winGLimit'} />}
                          value={winLimit}
                          InputProps={{disableUnderline: true}}
                          inputProps={{min: 1, max: constants.activity.VALUE_DEFAULT_MAX}}
                          onChange={this.onChange}
                          onKeyDown={textFieldIntegerOnKeyDown}
                          error={winLimitError}
                          helperText={winLimitError ? <FormattedMessage id='activity.validation.requiredEmptyOrMoreThanZero' /> : <FormattedMessage id='activity.manage.hintWinLimit'/>}
                        />
                        <Space horizontal={inputSpace} />
                      </div>
                      : null
                    }
                    {/*{this.enableWinGLimit && resetGameDays > 0 ?*/}
                    {/*  <div className={classes.viewColumnFullWidth}>*/}
                    {/*    <TextField*/}
                    {/*      variant="filled"*/}
                    {/*      fullWidth*/}
                    {/*      size="small"*/}
                    {/*      type="number"*/}
                    {/*      id="winGLimit"*/}
                    {/*      name="winGLimit"*/}
                    {/*      label={<FormattedMessage id='activity.manage.winGLimit'/>}*/}
                    {/*      value={winGLimit}*/}
                    {/*      InputProps={{disableUnderline: true}}*/}
                    {/*      inputProps={{min: 1, max: constants.activity.VALUE_DEFAULT_MAX}}*/}
                    {/*      onChange={this.onChange}*/}
                    {/*      onKeyDown={textFieldIntegerOnKeyDown}*/}
                    {/*      error={winGLimitError}*/}
                    {/*      helperText={winGLimitError ? winGLimitError : <FormattedMessage id='activity.manage.sectionHintTotalWinLimit' />}*/}
                    {/*    />*/}
                    {/*    <Space horizontal={inputSpace}/>*/}
                    {/*  </div>*/}
                    {/*  : null*/}
                    {/*}*/}

                  </div>
                  :null
                }
              </div>
              :null
            }
          </div>
          : null
        }
      </div>
    );
  }

  showInfoBar(messageId) {
    let {activityRewardedSearch} = this.state;
    this.setState({
      snackbarMessageId: messageId,
    });
    this.timeoutHandleId = setTimeout(() => {
      this.timeoutHandleId = null;
      if (activityRewardedSearch === this.state.activityRewardedSearch) {
        activityRewardedSearch = null;
      }
      this.setState({snackbarMessageId: null, activityRewardedSearch});
    }, 3000);
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  onFormSectionToggle = (section) => {
    let {sections} = this.state;
    const index = sections.indexOf(section);
    const eSections = cloneDeep(sections);
    const newState = !eSections[index].expand;
    eSections[index].expand = newState;
    let newReward = null;
    if (newState) {
      newReward = {
        type: 0,
        name: '',
        imageUrl: null,
        imageFiles: null,
      };
    }
    if (this.timeoutHandleId) {
      clearTimeout(this.timeoutHandleId);
    }
    this.setState({sections: eSections, newReward, isNewRewardAdded: false, showValidationMsg: false, showNewRewardValidationMsg: false});
  }

  onToggleEnableDisable = (event) => {
    const checked = event.target.checked;
    let rewardState;
    let winLimit;
    let winGLimit;
    const winPoints = 0;
    const activityRewarded = null;
    const activityRewardedSearch = null;
    this.slotValues.forEach((slotValue) => {
      slotValue.winPoints = 0;
      slotValue.offers = null;
    });
    if (checked) {
      rewardState = constants.activity.state.ACTIVE;
      winLimit = '';
      winGLimit = '';
      this.slotValues.forEach((slotValue) => {
        slotValue.winLimit = '';
      });
    } else {
      rewardState = constants.activity.state.DELETE;
      winLimit = 0;
      winGLimit = 0;
      this.slotValues.forEach((slotValue) => {
        slotValue.winLimit = 0;
      });
    }
    this.updateState({rewardState: rewardState, winLimit, winGLimit, winPoints, activityRewarded, activityRewardedSearch});
  };

  getImageView(placeholderImageId) {
    const {newReward} = this.state;
    const {classes, isXS} = this.props;
    const space = isXS ? FIELD_SPACE : 0;
    return (
      <div className={classes.viewColumn}>
        <SingleFilePicker
          label={this.context.intl.formatMessage({id: placeholderImageId})}
          required={false}
          filesLimit={1}
          showPreviewsInDropzone={true}
          acceptedFiles={ACCEPTED_IMAGE_MIMES}
          maxFileSize={IMAGE_MAX_SIZE}
          maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
          aspectRatio={16/9}
          initialFiles={newReward.initialFiles}
          onChange={(files) => {
            this.onChangeFiles(files, 'imageUrl');
          }}
          onDelete={(file) => {
            this.onDeleteFile(file, 'imageUrl');
          }}
        />
        <Space horizontal={space}/>
      </div>
    );
  }

  onChangeFiles(files, id) {
    let {newReward} = this.state;
    const {imageUrl} = newReward;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'imageUrl') {
      eImageUrl = imageUrl;
      keyImageUrl = 'imageUrl';
      keyImageFiles = 'imageFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    newReward[keyImageUrl] = lFileUrl;
    newReward[keyImageFiles] = lFiles;
    this.setState({showValidationMsg: false, showNewRewardValidationMsg: false, newReward});
  }

  onDeleteFile(file, id) {
    let {newReward} = this.state;
    const {imageUrl, imageFiles,} = newReward;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'imageUrl') {
      eImageUrl = imageUrl;
      eImageFiles = imageFiles;
      keyImageUrl = 'imageUrl';
      keyImageFiles = 'imageFiles';
      keyIsImageDeleted = 'isImageDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    newReward[keyImageUrl] = lFileUrl;
    newReward[keyImageFiles] = lFiles;
    newReward[keyIsImageDeleted] = true;
    this.setState({showValidationMsg: false, showNewRewardValidationMsg: false, newReward});
  }

  areWinValuesCorrect() {
    const {winLimit, winGLimit, rewardsData, resetGameDays} = this.state;
    if (!this.disableWinLimit) {
      if (this.enableWinGLimit && resetGameDays > 0) {
        if (winGLimit && ValueHelper.getEnglishValue(winGLimit) <= 0) {
          return false;
        }
      }
      if (winLimit && ValueHelper.getEnglishValue(winLimit) <= 0) {
        return false;
      }
    }
    return rewardsData.offers && rewardsData.offers.length > 0;
  }

  onChange = (event) => {
    const {rewardState, winPoints, winLimit, winGLimit, rewardsData} = this.state;
    let rewardStateEff = rewardState;
    let winLimitEff = winLimit;
    let winGLimitEff = winGLimit;
    let value = event.target.value;
    if (event.target.name === 'winPoints'
      || event.target.name === 'winLimit'
      || event.target.name === 'winGLimit'
    ) {
      const maxValue = constants.activity.VALUE_DEFAULT_MAX;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
      if (!value && value !== 0) {
        value = '';
      }
      if (event.target.name === 'winLimit') {
        winLimitEff = value;
      } else if (event.target.name === 'winGLimit') {
        winGLimitEff = value;
      }
      if (event.target.name === 'winPoints') {
        if (value > 0) {
          rewardStateEff = constants.activity.state.ACTIVE;
          if (!winPoints || winPoints <= 0) {
            winLimitEff = '';
            winGLimitEff = '';
          }
        } else {
          rewardStateEff = constants.activity.state.INACTIVE;
          winLimitEff = '';
          winGLimitEff = '';
        }
      }
    } else if (event.target.name === 'resetGameDays' || event.target.name === 'winnersByValue') {
      let maxValue = constants.activity.VALUE_DEFAULT_MAX;
      if (event.target.name === 'resetGameDays') {
        maxValue = 365;
      }
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    }

    if (event.target.name === 'winnersBySelected' && value && value.showWinnersByValue) {
      this.updateState({[event.target.name]: value, showValidationMsg: false, winnersByValue: 0});
    } else {
      this.updateState({
        [event.target.name]: value,
        rewardState: rewardStateEff, rewardsData: rewardsData,
        winLimit: winLimitEff, winGLimit: winGLimitEff,
        showValidationMsg: false, showNewRewardValidationMsg: false
      });
    }
  };

  onChangeActivityRewarded = (value) => {
    if (value.length > 1) {
      this.updateState({activityRewardedSearch: value, activityRewarded: null, isActivityRewardedLoading: true, showValidationMsg: false, showNewRewardValidationMsg: false});
      this.fetchActivityWinRewards(value);
    } else {
      this.updateState({activityRewardedSearch: value, activityRewarded: null, showValidationMsg: false, showNewRewardValidationMsg: false});
    }
  };

  onSelectActivityRewarded = (value) => {
    const {rewardsData} = this.state;
    const offers = rewardsData.offers || [];
    let isNew = true;
    if (value) {
      offers.forEach((offer) => {
        if (value.id === offer.id) {
          isNew = false;
        }
      });
      if (isNew) {
        offers.push(value);
        if (offers.length > this.maxWinOffersCount) {
          offers.splice(0, 1);
        }
      }
    }
    rewardsData.offers = offers;
    this.setState({
      activityRewardedSearch: value ? value.name : '',
      rewardsData: rewardsData,
      showValidationMsg: false,
      showNewRewardValidationMsg: false,
      isActivityRewardedLoading: false,
    });
    if (value) {
      this.showInfoBar('activity.manage.rewardSelected');
    }
  };

  onDeletedReward = (reward, index) => {
    let {rewardsData, winPoints} = this.state;
    if (reward.id === -1) {
      winPoints = '';
    }
    if (rewardsData.offers) {
      rewardsData.offers.splice(index, 1);
    }
    this.setState({rewardsData: rewardsData,
      winPoints: winPoints,
      showValidationMsg: false,
      showNewRewardValidationMsg: false
    });
  };

  onChangeForReward = (event) => {
    const {newReward} = this.state;
    let value = event.target.value;
    if (event.target.name === 'fee') {
      const maxValue = constants.activity.VALUE_DEFAULT_MAX;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    }
    newReward[event.target.name] = value;
    this.setState({newReward: newReward, showValidationMsg: false, showNewRewardValidationMsg: false});
  };

  onCancelRewardClicked = () => {
    this.setState({newReward: null, showNewRewardValidationMsg: false});
  }

  onSaveRewardClicked = () => {
    const {activityData} = this.props;
    const {newReward, rewardsData} = this.state;
    if (!newReward || !newReward.type || !newReward.name
      || (newReward.type === constants.activity.types.VOUCHER && (!newReward.vouchers || newReward.vouchers.length === 0))
      || (newReward.usageType === constants.activity.usageTypes.LOYALTY && (!newReward.fee || ValueHelper.getEnglishValue(newReward.fee) <= 0))) {
      this.setState({showNewRewardValidationMsg: true});
      return;
    }

    const data = {
      type: constants.activity.types.OFFER,
      usageType: activityData.usageType,
      fee: newReward.fee ? ValueHelper.getEnglishValue(newReward.fee) : 0,
      createdForId: activityData.business.id,
      startAt: activityData.startAt.toJSON(),
      endAt: activityData.endAt.toJSON(),
      title: newReward.name,
      consumableAt: newReward.type === constants.activity.types.VOUCHER ? 10 : 0,
    };
    if (newReward.description) {
      data.description = newReward.description;
    }
    if (newReward.vouchers && newReward.vouchers.length > 0) {
      const vouchers = [];
      newReward.vouchers.forEach((voucher) => {
        vouchers.push(JSON.stringify(voucher));
      });
      data.vouchers = vouchers;
    }
    let files = [];
    if (newReward.imageFiles && newReward.imageFiles.length > 0) {
      files.push({'id': 'imageFile', 'file': newReward.imageFiles[0]});
    }
    if (files && files.length > 0) {
      files.forEach((file) => {
        data[file.id] = file.file;
      });
    }
    this.setState({showValidationMsg: false, showNewRewardValidationMsg: false, newRewardError: null});
    this.props.addNewRewardInActivity(data).then((response) => {
      if (response) {
        const newData = response.data;

        const offers = rewardsData.offers || [];
        offers.splice(0, 0, newData);
        if (offers.length > this.maxWinOffersCount) {
          offers.splice(offers.length - 1, 1);
        }
        rewardsData.offers = offers;
        this.setState({
          rewardsData: rewardsData,
          showValidationMsg: false,
          showNewRewardValidationMsg: false,
          newReward: null,
          isNewRewardAdded: true,
        });
        this.showInfoBar('activity.manage.rewardAddedSnack');
      }
    }).catch((response) => {
      let errorMessage = null;
      if (response.data && response.data.error) {
        errorMessage = response.data.error;
      } else {
        errorMessage = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
      }
      this.setState({showNewRewardValidationMsg: true, newRewardError: errorMessage});
    });
  };

  fetchActivityWinRewards(value, slotOptionIndex = undefined) {
    if (this.clearTimeout) {
      clearTimeout(this.clearTimeout);
    }
    this.clearTimeout = setTimeout(() => {
      const {activityData} = this.props;
      const usageType = activityData.usageType === constants.activity.usageTypes.LOYALTY ? activityData.usageType : null;
      this.props.fetchActivityWinRewards(value, usageType).then(() => {
        if (slotOptionIndex !== undefined) {
          this.slotValues[slotOptionIndex].isActivityRewardedLoading = false;
          this.reloadView();
        } else {
          this.updateState({isActivityRewardedLoading: false});
        }
      });
    }, 200);
  }
}

ManageActivityRecur.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
  fetchActivityWinRewards: PropTypes.func,
  addNewRewardInActivity: PropTypes.func,
};

ManageActivityRecur.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActivityWinRewards: (search, usageType) => dispatch(fetchActivityWinRewards(search, usageType)),
    addNewRewardInActivity: (data) => dispatch(addNewRewardInActivity(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityRecur))
);
